import React, { useState } from "react";
import { Modal, Form, Input, Select, Button, notification } from "antd";
import {
  useUpdateUserAccountMutation,
  useUpdateUserEmailMutation,
  useResendInvitationMutation,
} from "../../../../services/auth.service";
import toast from "react-hot-toast";
import { errorBlock } from "../../../../controllers/errorBlock";
import { AiFillEdit } from "react-icons/ai";
export const UserProfileUpdate = ({
  visible,
  onClose,
  selecteduser,
  refreshBtn,
}) => {
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);

  const [updateUserEmail, { isLoading, data, error }] =
    useUpdateUserEmailMutation(); // Use the mutation

  const [updateUserAccount, { isLoading: updatingdata }] =
    useUpdateUserAccountMutation();

  const [resendInvitation, { isLoading: isResendingInvitation }] =
    useResendInvitationMutation();
  // Function to handle form submission
  const handleFormSubmit = async (values) => {
    if (!isEditMode) {
      return;
    }

    try {
      const response = await updateUserAccount({
        firstname: values.firstname || "",
        lastname: values.lastname || "",
        username: selecteduser?.username,
        email: values.email || "",
        phone: values.phone || "",
      }).unwrap();

      if (response.response === "success") {
        notification.success({
          message: "Success",
          description: "User information updated successfully!",
        });
        refreshBtn((prev) => !prev);
        onClose();
      } else {
        notification.error({
          message: response.message,
          description: "Failed to update account",
        });
      }
    } catch (error) {
      errorBlock(error);
    }
  };

  const handleResendInvitation = async () => {
    try {
      const response = await resendInvitation(selecteduser?.username).unwrap();

      if (response.response === "success") {
        notification.success({
          message: "Success",
          description: "Invitation resent successfully!",
        });
      } else {
        notification.error({
          message: "Error",
          description: response.message || "Failed to resend invitation",
        });
      }
    } catch (error) {
      errorBlock(error);
    }
  };
  return (
    <Modal
      title={
        <div className="flex items-center justify-between w-full">
          <p>Edit User Information</p>
          <div className="gap-4">
            <Button
              type=""
              onClick={() => setIsEditMode(!isEditMode)}
              className=" !text-blue-600 px-4 hover:bg-blue-50"
            >
              {isEditMode ? "Cancel Edit" : "Edit profile"}
            </Button>
            {isEditMode && (
              <Button
                loading={updatingdata}
                key="submit"
                type="primary"
                className="ml-2"
                onClick={() => form.submit()}
                disabled={!isEditMode}
              >
                Save
              </Button>
            )}
          </div>
        </div>
      }
      visible={visible}
      onCancel={onClose}
      closable={false}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={selecteduser}
        onFinish={handleFormSubmit}
        className="relative"
      >
        <div className="flex absolute right-1 top-44 z-10 justify-between items-center mb-4">
          <p
            className={`text-blue-600 !m-0 cursor-pointer ${
              isResendingInvitation
                ? "opacity-50 cursor-not-allowed"
                : "hover:text-blue-800"
            }`}
            onClick={
              !isResendingInvitation ? handleResendInvitation : undefined
            }
          >
            {isResendingInvitation
              ? "Sending invitation..."
              : "Resend invitation"}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="First Name"
            name="firstname"
            rules={
              isEditMode
                ? []
                : [{ required: true, message: "First name is required" }]
            }
          >
            <Input disabled={!isEditMode} />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastname"
            rules={
              isEditMode
                ? []
                : [{ required: true, message: "Last name is required" }]
            }
          >
            <Input disabled={!isEditMode} />
          </Form.Item>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Username is required" }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="Phone"
            name="phone"
            rules={
              isEditMode
                ? []
                : [
                    { required: true, message: "Phone number is required" },
                    // { pattern: /^\d{10,15}$/, message: "Invalid phone number" },
                  ]
            }
          >
            <Input disabled={!isEditMode} />
          </Form.Item>
        </div>

        <Form.Item
          label={"Email"}
          name="email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Invalid email format" },
          ]}
        >
          <Input disabled={!isEditMode} />
        </Form.Item>

        <Form.Item
          label="Active Status"
          name="activestatus"
          rules={[{ required: true, message: "Active status is required" }]}
        >
          <Select disabled={!isEditMode}>
            <Select.Option value="active">Active</Select.Option>
            <Select.Option value="inactive">Inactive</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Date Registered" name="dateregistered">
          <Input disabled />
        </Form.Item>
      </Form>
    </Modal>
  );
};

// const App = () => {
//

//   return (
//     <div>
//       <Button type="primary" onClick={() => setIsModalVisible(true)}>
//         Open User Form
//       </Button>
//       <UserFormModal
//         visible={isModalVisible}
//         onClose={() => setIsModalVisible(false)}
//       />
//     </div>
//   );
// };

// export default App;
